/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 10:14:55
 * @LastEditTime: 2022-06-06 15:55:39
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/SubscriptionName/index.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const SubscriptionName = ({ reportSubscriptionName, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      titleClassName={css.titleClassName}
      title={reportSubscriptionName}>
      <Form.Item
        name='name'
        className={css.formItem}
        rules={[
          {
            required: true,
            message: getI18n(
              'reportSubscription.reportSubscriptionDetail.subscriptionName.msg',
            ),
          },
        ]}
        label={
          <Label
            title={getI18n(
              'reportSubscription.reportSubscriptionDetail.subscriptionName.name',
            )}
            nameKey='name'
            textLength={100}
          />
        }
        labelCol={{ span: 24 }}>
        <Input size='large' maxLength={100} disabled={disabled} />
      </Form.Item>
    </SectionWrapper>
  );
};

export default SubscriptionName;
